import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import packageJson from '../package.json'; // Adjust the path as needed
import { Device, type DeviceInfo } from '@capacitor/device';

enum Platform {
  Android = 'android',
  Ios = 'ios',
  Web = 'web',
  Tablet = 'tablet',
  Ipad = 'ipad',
  MobileWeb = 'mobileweb'
}

export const usePlatformStore = defineStore('platformStore', () => {
  const platform = ref(Capacitor.getPlatform() as Platform);

  const isMobile = ref(Capacitor.isNativePlatform());
  const isAndroid = computed(() => platform.value === Platform.Android);
  const isIos = computed(() => platform.value === Platform.Ios);
  const isWeb = computed(() => platform.value === Platform.Web);
  const isTablet = computed(() => getPlatforms().includes(Platform.Tablet));
  const isIPad = computed(() => getPlatforms().includes(Platform.Ipad));
  const isMobileWeb = computed(() => getPlatforms().includes(Platform.MobileWeb));

  async function getSoftwareVersion() {
    if (isMobile.value) {
      const appInfo = await App.getInfo();

      return appInfo.version;
    } else {
      return packageJson.version;
    }
  }

  async function getPlatformVersion() {
    const deviceInfo: DeviceInfo = await Device.getInfo();

    switch (deviceInfo.platform) {
      case Platform.Ios:
        return deviceInfo.iOSVersion?.toString() ?? 'Unknown iOS Version';
      case Platform.Android:
        return deviceInfo.androidSDKVersion?.toString() ?? 'Unknown Android Version';
      case Platform.Web:
        return deviceInfo.osVersion ?? 'Unknown Web Version';
      default:
        return Platform.Web;
    }
  }

  return { platform, isMobile, isAndroid, isIos, isWeb, isIPad, isTablet, isMobileWeb, getSoftwareVersion, getPlatformVersion };
});
